import chip25 from "./chip25.png";
import chip100 from "./chip100.png";
import chip500 from "./chip500.png";

export const CHIP_500 = chip500;
export const CHIP_100 = chip100;
export const CHIP_25 = chip25;